import React from 'react';

type Props = {
  className?: string;
};

const ProductCapabilitiesOverview: React.FC<Props> = ({ className }) => {
  return (
    <>
      <div className={`bg-gray-100 ${className}`}>
        <div className="max-w-7xl py-10  lg:py-24 ">
          <dl className="md:mt-12 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 lg:grid-cols-4 lg:gap-x-8">
            <div className="flex">
              <svg
                className="flex-shrink-0 h-6 w-6 text-primary-600"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
              <div className="ml-3">
                <dt className="text-lg leading-6 font-medium text-gray-900">
                  Digital Mobile Menus
                </dt>
                <dd className="mt-2 text-base text-gray-500">
                  {/* <a
                    id={'SdEv1p'}
                    className={'text-primary-600 hover:text-primary-700'}
                    href={'/product?ref=product_overview_SdEv1p_inline#safety'}
                    onClick={e => {
                      // e.preventDefault();
                      // @ts-ignore
                      analytics.track('Safety Clicked', {
                        title: 'protect_your_staff_and_guests',
                        action: 'click',
                        location: 'product_overview',
                        destination: 'product_safety',
                      });
                      // history.push('/use-cases/fsr#margin-impact?ref=home_product_aoBx9N_inline')
                    }}
                  >
                    Protect your staff and guests
                  </a>{' '} */}
                  Responsive menus built for mobile for easy visual viewing and
                  a better guest experience.
                </dd>
              </div>
            </div>

            <div className="flex">
              <svg
                className="flex-shrink-0 h-6 w-6  text-primary-600"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
                />
              </svg>
              <div className="ml-3">
                <dt className="text-lg leading-6 font-medium text-gray-900">
                  Dynamic QR Codes
                </dt>
                <dd className="mt-2 text-base text-gray-500">
                  Automated QR code generation and management to connect guests
                  to your digital menus
                  {/* <a
                    id={'fHlGjB'}
                    className={'text-primary-600 hover:text-primary-700'}
                    href={
                      '/use-cases/fsr?ref=product_overview_fHlGjB_inline#margin-impact'
                    }
                    onClick={e => {
                      // e.preventDefault();
                      // @ts-ignore
                      analytics.track('Impact Clicked', {
                        title: 'lean_and_flexible',
                        action: 'click',
                        location: 'product_overview',
                        destination: 'fsr_impact',
                      });
                      // history.push('/use-cases/fsr#margin-impact?ref=home_product_aoBx9N_inline')
                    }}
                  >
                    {' '}
                    lean and flexible{' '}
                  </a>{' '}
                  operation while making{' '}
                  <a
                    id={'6c0bN1'}
                    className={'text-primary-600 hover:text-primary-700'}
                    href={
                      '/use-cases/fsr?ref=product_overview_6c0bN1_inline#margin-impact'
                    }
                    onClick={e => {
                      // e.preventDefault();
                      // @ts-ignore
                      analytics.track('Impact Clicked', {
                        title: 'more_in_profits',
                        action: 'click',
                        location: 'product_overview',
                        destination: 'fsr_impact',
                      });
                      // history.push('/use-cases/fsr#margin-impact?ref=home_product_aoBx9N_inline')
                    }}
                  >
                    {' '}
                    more in profits
                  </a> */}
                  .
                </dd>
              </div>
            </div>

            <div className="flex">
              <svg
                className="flex-shrink-0 h-6 w-6  text-primary-600"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>

              <div className="ml-3">
                <dt className="text-lg leading-6 font-medium text-gray-900">
                  Mobile Order & Payment
                </dt>
                <dd className="mt-2 text-base text-gray-500">
                  Contactless mobile payment built right into your digital menu
                  for quick and easy ordering
                  {/* <a
                    id={'7JdcI1'}
                    className={'text-primary-600 hover:text-primary-700'}
                    href={
                      '/product?ref=product_overview_7JdcI1_inline#workflow'
                    }
                    onClick={e => {
                      // e.preventDefault();
                      // @ts-ignore
                      analytics.track('Workflow Clicked', {
                        title: 'standalone_product',
                        action: 'click',
                        location: 'product_overview',
                        destination: 'fsr_workflow',
                      });
                      // history.push('/use-cases/fsr#margin-impact?ref=home_product_aoBx9N_inline')
                    }}
                  >
                    {' '}
                    standalone product{' '}
                  </a>{' '}
                  or one that works with your
                  <a
                    id={'AnYW3H'}
                    className={'text-primary-600 hover:text-primary-700'}
                    href={
                      '/product?ref=product_overview_AnYW3H_inline#workflow'
                    }
                    onClick={e => {
                      // e.preventDefault();
                      // @ts-ignore
                      analytics.track('Workflow Clicked', {
                        title: 'existing_workflow',
                        action: 'click',
                        location: 'product_overview',
                        destination: 'fsr_workflow',
                      });
                      // history.push('/use-cases/fsr#margin-impact?ref=home_product_aoBx9N_inline')
                    }}
                  >
                    {' '}
                    existing workflow
                  </a> */}
                  .
                </dd>
              </div>
            </div>

            <div className="flex">
              <svg
                className="flex-shrink-0 h-6 w-6  text-primary-600"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M13 10V3L4 14h7v7l9-11h-7z"
                />
              </svg>

              <div className="ml-3">
                <dt className="text-lg leading-6 font-medium text-gray-900">
                  Powerful Central Dashboard
                </dt>
                <dd className="mt-2 text-base text-gray-500">
                  A simple yet powerful central hub to manage your menu, QR
                  codes, transactions, and more
                  {/* <a
                    id={'yr3TZ0'}
                    className={'text-primary-600 hover:text-primary-700'}
                    href={'/contact?ref=product_overview_yr3TZ0_inline'}
                    onClick={e => {
                      // e.preventDefault();
                      // @ts-ignore
                      analytics.track('Contact Clicked', {
                        title: 'right_now',
                        action: 'click',
                        location: 'product_overview',
                        destination: 'contact_hero',
                      });
                      // history.push('/use-cases/fsr#margin-impact?ref=home_product_aoBx9N_inline')
                    }}
                  >
                    right now
                  </a> */}
                  .
                </dd>
              </div>
            </div>
          </dl>
        </div>
      </div>
    </>
  );
};

export default ProductCapabilitiesOverview;
